import './App.css';
import Sorting from './Sorting/Sorting';

import { HashRouter as Router, Route, Switch } from 'react-router-dom';

function App() {
  return (
    <Sorting />
  );
}

export default App;
